export {};
//# sourceMappingURL=Provider.types.js.map